export { default as instanceCachingFactory } from "./instance-caching-factory";
export { default as predicateAwareClassFactory } from "./predicate-aware-class-factory";
